export const getAllContacts = ({ contacts }) => contacts.items;
export const getContactsLoading = ({ contacts }) => contacts.loading;
